export default __webpack_public_path__ + "static/media/logo-login.7b5ecc31.svg";